(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var types = require('./types');

var n = types.namedTypes;
var Type = types.Type;
var InvalidTypeError = require('./error').InvalidTypeError;

var visitorName = function visitorName(node) {
  var name = void 0;

  if (typeof node === 'string') {
    name = node;
  } else if (node instanceof Type) {
    name = node.name;
  } else {
    name = node.type;
  }

  return 'visit' + name;
};

var _build = function _build(visitors) {
  var programName = visitorName(n.Program);
  var program = visitors[programName] || function programFN(path) {
    this.traverse(path);
  };

  return function buildFN(node, options) {
    var tolerant = (options || {}).tolerant || false;
    var errors = [];
    var results = void 0;
    types.visit(node, Object.assign({}, visitors, defineProperty({}, programName, function (path) {
      try {
        program.call(this, path);
      } catch (e) {
        errors.push(e);
        if (tolerant) e.cancel();
      }
      results = path.node;
    })));

    if (!tolerant && errors.length !== 0) {
      throw errors[0];
    }

    if (errors.length) results.errors = errors;

    return results;
  };
};

function abort(visitor, path) {
  try {
    visitor.abort();
  } catch (e) {
    var error = new InvalidTypeError(path);
    error.cancel = function () {
      return e.cancel();
    };
    throw error;
  }
}

var combine = function combine(stack) {
  return function stackFN(path) {
    // Prepare children
    this.traverse(path);

    var next = stack.slice();
    var transform = next.shift();
    var node = void 0;

    while (transform) {
      try {
        node = transform.call(this, path);
        break;
      } catch (e) {
        // ignore error
      }
      transform = next.shift();
    }

    // No visitor passed, so assume type is invalid
    if (!node) abort(this, path);

    // Tranform the node
    path.replace(node);
  };
};

var Validator = function () {
  function Validator() {
    classCallCheck(this, Validator);
  }

  createClass(Validator, [{
    key: 'valid',
    value: function valid(type) {
      return this.transform(type, function () {
        return true;
      }, function (node) {
        return node;
      });
    }
  }, {
    key: 'transform',
    value: function transform() {
      for (var _len = arguments.length, tests = Array(_len), _key = 0; _key < _len; _key++) {
        tests[_key] = arguments[_key];
      }

      var type = tests.shift();
      var name = type.name;
      var nextTypes = this.types || {};
      var stack = nextTypes[name] || [];
      nextTypes[name] = stack.concat(tests);
      this.types = nextTypes;
      return this;
    }
  }, {
    key: 'visitors',
    value: function visitors() {
      var _this = this;

      return Object.keys(n).reduce(function (o, k) {
        return Object.assign(o, defineProperty({}, visitorName(k), _this.types[k] ? combine(_this.types[k]) : Validator.invalid));
      }, {});
    }
  }, {
    key: 'build',
    value: function build() {
      return _build(this.visitors());
    }
  }], [{
    key: 'abort',
    value: function abort(visitor, path) {
      try {
        visitor.abort();
      } catch (e) {
        var error = new InvalidTypeError(path);
        error.cancel = function () {
          return e.cancel();
        };
        throw error;
      }
    }
  }, {
    key: 'invalid',
    value: function invalid(path) {
      abort(this, path);
    }
  }, {
    key: 'valid',
    value: function valid(path) {
      this.traverse(path);
    }
  }]);
  return Validator;
}();

module.exports = Validator;

})));
//# sourceMappingURL=validator.js.map
